import { useEffect, useState } from "react";
import api from "../services/api";

export default function CompanyProfile() {
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(true);
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    api.get("/company-profile")
      .then((res) => {
        if (res.data?.id) {
          setForm(res.data);
          setEditMode(false);
        } else {
          setEditMode(true);
        }
        setLoading(false);
      })
      .catch(() => {
        setEditMode(true);
        setLoading(false);
      });
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (form.id) {
        await api.put(`/company-profile/${form.id}`, form);
        alert("Company profile updated");
      } else {
        const res = await api.post("/company-profile", form);
        setForm(res.data.data);
        alert("Company profile created");
      }
      setEditMode(false);
    } catch (err) {
      alert("Gagal menyimpan data");
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <>
      <h4 className="mb-4">🏢 Company Profile</h4>

      {/* ================= VIEW MODE ================= */}
      {!editMode && form.id && (
        <div className="card shadow-sm p-4">
          <h5 className="fw-bold">{form.nama_perusahaan}</h5>
          <p className="text-muted">{form.deskripsi}</p>

          <hr />

          <p><b>Email:</b> {form.email || "-"}</p>
          <p><b>Telepon:</b> {form.telepon || "-"}</p>
          <p><b>WhatsApp:</b> {form.whatsapp || "-"}</p>
          <p><b>Alamat:</b> {form.alamat || "-"}</p>

          <p><b>Instagram:</b> {form.instagram || "-"}</p>
          <p><b>Facebook:</b> {form.facebook || "-"}</p>
          <p><b>TikTok:</b> {form.tiktok || "-"}</p>

          <p><b>Shopee:</b> {form.shopee || "-"}</p>
          <p><b>Tokopedia:</b> {form.tokopedia || "-"}</p>
          <p><b>Lazada:</b> {form.lazada || "-"}</p>

          <p><b>Website:</b> {form.website || "-"}</p>

          <button
            className="btn btn-warning mt-3"
            onClick={() => setEditMode(true)}
          >
            ✏️ Edit
          </button>
        </div>
      )}

      {/* ================= FORM MODE ================= */}
      {editMode && (
        <form onSubmit={handleSubmit} className="card p-4 shadow-sm">
          <div className="row g-3">

            {/* BASIC */}
            <div className="col-md-6">
              <label className="form-label">Nama Perusahaan</label>
              <input className="form-control" name="nama_perusahaan" value={form.nama_perusahaan || ""} onChange={handleChange} required />
            </div>

            <div className="col-md-6">
              <label className="form-label">Email</label>
              <input className="form-control" name="email" value={form.email || ""} onChange={handleChange} />
            </div>

            <div className="col-md-6">
              <label className="form-label">Telepon</label>
              <input className="form-control" name="telepon" value={form.telepon || ""} onChange={handleChange} />
            </div>

            <div className="col-md-6">
              <label className="form-label">WhatsApp</label>
              <input className="form-control" name="whatsapp" value={form.whatsapp || ""} onChange={handleChange} />
            </div>

            {/* SOCIAL */}
            <div className="col-md-6">
              <label className="form-label">Instagram</label>
              <input className="form-control" name="instagram" value={form.instagram || ""} onChange={handleChange} />
            </div>

            <div className="col-md-6">
              <label className="form-label">Facebook</label>
              <input className="form-control" name="facebook" value={form.facebook || ""} onChange={handleChange} />
            </div>

            <div className="col-md-6">
              <label className="form-label">TikTok</label>
              <input className="form-control" name="tiktok" value={form.tiktok || ""} onChange={handleChange} />
            </div>

            {/* MARKETPLACE */}
            <div className="col-md-4">
              <label className="form-label">Shopee</label>
              <input className="form-control" name="shopee" value={form.shopee || ""} onChange={handleChange} />
            </div>

            <div className="col-md-4">
              <label className="form-label">Tokopedia</label>
              <input className="form-control" name="tokopedia" value={form.tokopedia || ""} onChange={handleChange} />
            </div>

            <div className="col-md-4">
              <label className="form-label">Lazada</label>
              <input className="form-control" name="lazada" value={form.lazada || ""} onChange={handleChange} />
            </div>

            {/* TEXTAREA */}
            <div className="col-12">
              <label className="form-label">Alamat</label>
              <textarea className="form-control" rows="2" name="alamat" value={form.alamat || ""} onChange={handleChange} />
            </div>

            <div className="col-12">
              <label className="form-label">Deskripsi</label>
              <textarea className="form-control" rows="3" name="deskripsi" value={form.deskripsi || ""} onChange={handleChange} />
            </div>

            <div className="col-12">
              <label className="form-label">Google Maps Embed</label>
              <textarea className="form-control" rows="2" name="google_maps" value={form.google_maps || ""} onChange={handleChange} />
            </div>

            {/* SEO */}
            <div className="col-md-6">
              <label className="form-label">SEO Title</label>
              <input className="form-control" name="seo_title" value={form.seo_title || ""} onChange={handleChange} />
            </div>

            <div className="col-md-6">
              <label className="form-label">SEO Description</label>
              <textarea className="form-control" rows="2" name="seo_description" value={form.seo_description || ""} onChange={handleChange} />
            </div>

            {/* ACTION */}
            <div className="col-12 d-flex gap-2">
              <button className="btn btn-primary">💾 Simpan</button>
              {form.id && (
                <button type="button" className="btn btn-secondary" onClick={() => setEditMode(false)}>
                  Batal
                </button>
              )}
            </div>
          </div>
        </form>
      )}
    </>
  );
}
